import React, { Component } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store/rootReducer';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import i18n from '../../../../i18n';
import CheckBox from '../../../../components/ui/checkBox/CheckBox';
import Button from 'react-bootstrap/Button';

interface LocalProps {
  closeModalAction: (keepModalOpen: boolean) => void;
  onBulkDeleteConfirmed: () => void;
  showModal: boolean;
}

class TransactionsBulkConfirm extends Component<AllProps> {
  state = {
    confirmRead: false,
  };

  /**
   * close modal, cancel delete.
   */
  onCancel = () => {
    this.setState({ confirmRead: false });
    this.props.closeModalAction(false);
  };

  onConfirm = () => {
    this.setState({ confirmRead: false });
    this.props.onBulkDeleteConfirmed();
  };

  render() {
    const modalStyles = {
      transition: 'opacity 0.5s ease-out',
      opacity: this.props.showModal ? 1 : 0,
    };

    return (
      <Modal show={this.props.showModal} centered={true} backdrop="static" onHide={this.onCancel} style={modalStyles}>
        <div className="modal-header">
          <h5 className="modal-title" id="qa-delete-tx-modal-title">
            {i18n.t('transactions:table.deleteTxns')}
          </h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label={i18n.t('common:actions.close')}
            id={'qa-delete-tx-modal-btn-close-icon'}
            title={i18n.t('common:actions.close')}
            onClick={this.onCancel}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <Modal.Body id={'qa-delete-tx-modal-body-text'}>
          <div>
            <Row className={'ml-2 mr-2'}>
              <p>
                {i18n.t('transactions:table.bulkDeleteWarn')}{' '}
                <strong className="text-break">{this.props.totalTransactionsSelected}</strong>
                {' selected'}
                {this.props.totalTransactionsSelected === 1
                  ? ` ${i18n.t('transactions:table.txn')}`
                  : ` ${i18n.t('transactions:table.txns')}`}
                ?{i18n.t('transactions:table.selectedPrefix')}
                <strong className="text-break">{i18n.t('transactions:table.transactionsBold')}</strong>
                {i18n.t('transactions:table.selectedSuffix')}
              </p>
            </Row>
            <Row className={'ml-2'}>
              <CheckBox
                onCheck={() => {
                  this.setState({
                    confirmRead: !this.state.confirmRead,
                  });
                }}
                checked={this.state.confirmRead}
                label={'I confirm, that I want to delete all selected transactions.'}
              />
            </Row>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button id={'qa-delete-tx-modal-btn-cancel'} variant="link" onClick={this.onCancel}>
            {i18n.t('common:actions.cancel')}
          </Button>
          <button
            type="button"
            id={'qa-delete-tx-modal-btn'}
            className="btn btn-danger"
            onClick={this.onConfirm}
            disabled={this.state.confirmRead === false}
          >
            <span aria-hidden="true">Delete</span>
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => {
  return {
    totalTransactionsSelected: state.transactions.selectedTransactionsCount,
  };
};

type MapToStateProps = ReturnType<typeof mapStateToProps>;
type AllProps = LocalProps & MapToStateProps & RouteComponentProps<any>;

export default withRouter(connect(mapStateToProps)(TransactionsBulkConfirm));
